"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findCellDepIndexByTypeFromTransactionSkeleton = void 0;
const lumos_1 = require("@ckb-lumos/lumos");
const config_1 = require("../config");
const cell_1 = require("./cell");
const script_1 = require("./script");
async function findCellDepIndexByTypeFromTransactionSkeleton(props) {
    const config = props.config ?? (0, config_1.getSporeConfig)();
    const rpc = new lumos_1.RPC(config.ckbNodeUrl);
    const cellDeps = props.txSkeleton.get('cellDeps');
    for await (const [index, cellDep] of cellDeps.toArray().entries()) {
        const target = await (0, cell_1.getCellWithStatusByOutPoint)({
            outPoint: cellDep.outPoint,
            rpc,
        });
        if (target.cell?.cellOutput.type && (0, script_1.isScriptValueEquals)(target.cell.cellOutput.type, props.type)) {
            return index;
        }
    }
    return -1;
}
exports.findCellDepIndexByTypeFromTransactionSkeleton = findCellDepIndexByTypeFromTransactionSkeleton;
//# sourceMappingURL=cellDep.js.map